module.exports = __webpack_public_path__ + "img/img1_10.9c04ee45.jpeg";